import { useCallback, useState } from 'react'
import { Platform, Pressable } from 'react-native'
import { useTranslation } from 'react-i18next'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import TileBlur from '@ui/tiles/TileBlur'
import Button from '@ui/buttons/Button'
import EyetestModal from '@order/modals/Eyetest/EyetestModal'
import { useCustomer } from 'hooks/useSession'

export default function EyetestSection() {
  const { animation, onPressIn, onPressOut } = useAnimatedPress()
  const { t } = useTranslation(['customer'])
  const text = 'customer:home.sections.eyetest'

  const customer = useCustomer()
  const [modalOpen, setModalOpen] = useState(false)

  const openModal = useCallback(() => setModalOpen(true), [])
  const closeModal = useCallback(() => setModalOpen(false), [])

  const onPress = () => openModal()

  return (
    <>
      <Pressable
        onPress={onPress}
        onPressIn={onPressIn}
        onPressOut={onPressOut}
        className="flex-1"
      >
        <TileBlur
          variant="small"
          title={t(`${text}.title`)}
          desc={t(`${text}.desc`)}
          cta={
            <Button
              noninteractive
              animation={animation}
              onPress={onPress}
              size="sm"
              variant="outlined"
              label={t(`${text}.cta`)}
            />
          }
          glassProps={{
            animation,
            image: require('@/images/eyetest.png'),
            imageWrapperStyle: {
              transformOrigin: 'bottom right',
              transform: [
                {
                  rotate: Platform.select({ default: '-13deg', web: '7deg' }),
                },
              ],
              width: Platform.select({ default: '125%', web: '100%' }),
              height: Platform.select({ default: '125%', web: '100%' }),
            },
            imageStyle: {
              opacity: 1,
              transform: [
                { translateX: Platform.select({ default: 100, web: 50 }) },
                { translateY: Platform.select({ default: 45, web: 25 }) },
              ],
            },
            blur: Platform.select({ default: 100, web: 50 }),
            blurStyle: Platform.select({
              default: {
                opacity: 0.75,
                transform: [
                  { translateX: -110 },
                  { translateY: 25 },
                  { scale: 1.25 },
                  { rotate: '-13deg' },
                ],
              },
              web: {
                opacity: 1,
                transform: [
                  { translateX: 25 },
                  { translateY: -25 },
                  { scale: 1 },
                  { rotate: '0deg' },
                ],
              },
            }),
          }}
        />
      </Pressable>
      <EyetestModal key={customer?.id} open={modalOpen} close={closeModal} />
    </>
  )
}
